import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './TermsPage.css';

const TermsPage = () => {
  return (
    <>
      <Navbar />
      <div className="terms-page">
        <div className="terms-container">
          <div className="terms-header">
            <h1>Terms & Conditions</h1>
            <p>General conditions of Sale and Privacy Policy by Aurora CM Group Ltd.</p>
            <p className="terms-updated">Please read these terms carefully before using our services.</p>
          </div>

          <div className="terms-content">

            <section className="terms-section">
              <h2>1. Definitions and Terms</h2>
              <p><strong>Aurora:</strong> is the commercial name (brand) of Aurora CM Group Ltd, a legal entity with headquarters in Unnumbered House, Behind Kingdom Bookshop, Ako Adjei Road, OSU, Kinbu Street, Accra Ghana registered at the Trade Register with number: CS066340522, having the Fiscal Code: C0061772755.</p>
              <p><strong>Site/website:</strong> represents the online store belonging to Aurora CM Group Ltd, hosted at www.auroragh.com and its subdomains, through which the user has access to information on the services and products offered by Aurora CM Group Ltd.</p>
              <p><strong>User:</strong> represents the person who accesses the site, for private or professional purposes, and who has accepted the terms and conditions of this site, thus fulfilling all the requirements of the registration process.</p>
              <p><strong>Seller:</strong> Aurora CM Group Ltd. legal entity.</p>
              <p><strong>Buyer/customer:</strong> can be any natural person who is over 16 years old or legal person who makes an order through the website.</p>
              <p><strong>Abusive use:</strong> represents the use of the site in a way contrary to the practice in the field, the regulations and the legislation in force or in any other way that may cause damage to Aurora CM Group Ltd.</p>
              <p><strong>Newsletter:</strong> means of periodic information, exclusively in electronic format, on the products and services and/or promotions carried out by Aurora in a certain period of time.</p>
            </section>

            <section className="terms-section">
              <h2>2. Site Content</h2>
              <p>The information published on the site is information of general interest, the products sold by Aurora, its partners and other information considered to be of interest to users. The products presented are for presentation purposes only, which is why there may be variations in size, colour, and consistency of the delivered products. The products delivered will be of average market quality, Aurora making every effort to ensure that they are as identical as possible to the products in the presentation photos.</p>
            </section>

            <section className="terms-section">
              <h2>3. Use of the Site</h2>
              <p>The user undertakes to access and use the site for purposes and by means that do not constitute abusive use. We draw your attention to the fact that the purchase process leads to the conclusion of a true contract of sale, which is why your option to buy does not create obligations only for the seller, but also for the buyer.</p>
            </section>

            <section className="terms-section">
              <h2>4. Limitation of Liability</h2>
              <p>The company is not and cannot be held responsible for damages caused by errors, inaccuracies or non-updating of the information published or maintained on the site, which are not due to its fault.</p>
              <p>In the event that prices or other details relating to products/promotions have been displayed incorrectly, we reserve the right to cancel the delivery of that product and notify the customer as soon as possible.</p>
              <p>The prices of the products on this website are informative and subject to change without notice. The company reserves the right to complete and modify any information on the website.</p>
            </section>

            <section className="terms-section">
              <h2>5. Placing an Order</h2>
              <p>Any buyer can place orders on the website, by adding the selected products to the shopping cart and submitting this order for processing. Orders are delivered between 1 and 7 business days depending on product availability, buyer's address and the date the order was placed.</p>
              <p>Adding a product to the shopping cart, without finalizing the order, does not result in the registration of the order and thus also the reservation of the respective product.</p>
              <p>Aurora reserves the right to cancel orders for products displayed on the site as a result of technical errors, as well as those that, due to technical malfunctions/errors/bugs, present ridiculous or obviously erroneous prices.</p>
            </section>

            <section className="terms-section">
              <h2>6. Prices</h2>
              <p>Prices at all times are quoted in Ghana Cedis without VAT. Applicable prices charged are prices published on the website.</p>
            </section>

            <section className="terms-section">
              <h2>7. Delivery Policy</h2>
              <p>The delivery of orders for physical products is done by courier free of charge in the Accra region. Orders outside Greater Accra region will be sent by courier that should be paid by the customer at reception of goods.</p>
              <p>The delivery time is between 1 and 7 working days.</p>
              <p>The receipt of the products represents the customer's acceptance that the products have arrived in good condition.</p>
            </section>

            <section className="terms-section">
              <h2>8. Cancellation Policy</h2>
              <p>Once an order is confirmed no cancellations are accepted. And consequently, no refund will be issued.</p>
              <p>If the received product has perished and when the package is opened it is in a condition unsuitable for consumption, you can contact us with photos and we will replace your product.</p>
            </section>

            <section className="terms-section">
              <h2>9. Methods of Payment</h2>
              <p>Payment for products can only be made online. To guarantee the safety of transactions, Aurora uses the <strong>Paystack Online Payment Gateway</strong>, MTN Mobile Money, Telecel Cash and Airtel Money platforms.</p>
              <p>When you pay online with a bank card, you will be redirected to Paystack Online Payment Gateway, a secure payment platform. No additional fees are charged for online bank card transactions.</p>
            </section>

            <section className="terms-section">
              <h2>10. Warranty</h2>
              <p>Aurora, as a seller, ensures the quality of the products. If the received product has perished and is in a condition unsuitable for consumption, which you can prove with photos, contact us and we will replace your product.</p>
              <p>Contact us at: <a href="tel:0550866710">0550866710</a> or <a href="mailto:sales@auroragh.com">sales@auroragh.com</a></p>
            </section>

            <section className="terms-section">
              <h2>11. Processing of Personal Data</h2>

              <h3>11.1 Collection of Data</h3>
              <p>Aurora CM Group Ltd may collect personal data when you register on our website, subscribe to the Aurora Prestige Club, place an order, make an online payment, subscribe to newsletters, or contact us. Collected data may include name, address, phone number, email address, payment details, and transaction history.</p>

              <h3>11.2 Purpose of Processing</h3>
              <ul>
                <li>To process and deliver orders</li>
                <li>To manage memberships, subscriptions, and loyalty programs</li>
                <li>To facilitate secure online payments</li>
                <li>To improve products, services, and the website experience</li>
                <li>To send offers and promotional materials where consent is given</li>
                <li>To comply with legal and regulatory obligations</li>
              </ul>

              <h3>11.3 Data Storage and Security</h3>
              <p>Aurora ensures that all personal data is stored securely and protected against unauthorized access. Industry-standard encryption and secure payment platforms are used for transactions.</p>

              <h3>11.4 Sharing of Data</h3>
              <p>Personal data may be shared with trusted third-party providers strictly for payment processing, delivery and logistics, and IT/website hosting services.</p>

              <h3>11.5 User Rights</h3>
              <p>Users have the right to access, correct, update, or request deletion of their personal data. They may withdraw consent for marketing communications at any time.</p>

              <h3>11.6 Retention Period</h3>
              <p>Personal data will only be kept for as long as necessary to fulfil the purposes above or as required by law.</p>

              <h3>11.7 Contact for Data Protection</h3>
              <p>For all questions regarding personal data: <a href="mailto:accounts@auroragh.com">accounts@auroragh.com</a> / Data Protection Officer: <a href="tel:0505078077">0505078077</a></p>
            </section>

            <section className="terms-section">
              <h2>12. Newsletter</h2>
              <p>Any visitor to the site can subscribe to Aurora newsletters. The customer can opt out of receiving newsletters at any time by clicking on the unsubscribe link present in all Aurora newsletters.</p>
            </section>

            <section className="terms-section">
              <h2>13. Cookies Policy</h2>
              <p>By entering auroragh.com website the user accepts the use of cookies. The Company shall not be liable for any loss, costs, lawsuits, claims, expenses or other liabilities, if these are directly caused by non-compliance with the terms and conditions.</p>
            </section>

            <section className="terms-section">
              <h2>14. Membership / Subscriptions</h2>
              <p>Membership offers can be accessed at <a href="mailto:sales@auroragh.com">sales@auroragh.com</a>.</p>
              <p>Aurora subscription: at a payment of GHS 200.00 per month, or GHS 2,160.00 (20% discount) per year, you become a member of the "Aurora Prestige Club" and receive a 10% discount on all products.</p>
              <p>The subscription is recurring and is renewed monthly or annually until an express notification to cancel is received.</p>
            </section>

            <section className="terms-section">
              <h2>15. Complaints, Notices or Suggestions</h2>
              <p>For complaints, notifications or suggestions, the Aurora team is available from Monday to Friday between 09:00 and 17:00 at <a href="mailto:orders@auroragh.com">orders@auroragh.com</a>.</p>
              <p>Any complaint must be accompanied by: order number, waybill (AWB), reason for complaint, evidential photos and alleged causes. The maximum term for resolving complaints is 30 calendar days from their receipt.</p>
            </section>

            <section className="terms-section">
              <h2>16. Applicable Law</h2>
              <p>The general conditions of Aurora CM Group Ltd as well as the privacy policy are subject to Ghanaian law. Any unsolved dispute should be settled in front of the court in Accra.</p>
            </section>

          </div>

          <div className="terms-footer">
            <p>© {new Date().getFullYear()} Aurora CM Group Ltd. All rights reserved.</p>
            <p>For any questions: <a href="mailto:sales@auroragh.com">sales@auroragh.com</a></p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsPage;